import React from 'react';
import s from './TagsPopup.scss';
export var TagsPopupSection = function (_a) {
    var title = _a.title, description = _a.description, children = _a.children;
    return (React.createElement("div", { className: s['section'] },
        React.createElement("div", { className: s['section-container'] },
            React.createElement("div", { className: s['section-name'] }, title),
            React.createElement("div", { className: s['section-description'] }, description)),
        React.createElement("div", { className: s['section-container'] }, children)));
};
export default TagsPopupSection;
//# sourceMappingURL=TagsPopupSection.js.map